//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.GPrilohyPodavanehoDokumentuDlg.ts    </Name>
//    <Description>                                                             </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-12-28                                                  </Created>
//  </FileHeader>


namespace Gordic.Pod.WebControls {
    const { gcontent } = Decorators



    /**
     * GPrilohyPodavanehoDokumentuDlg
     *
     * @returns
     */
    @gcontent
    export class GPrilohyPodavanehoDokumentuDlg extends GContentBase {
     

        private mainGrid?: JQuery<HTMLElement>
        private view: Gordic.Data.View<WebControls.GPrilohyPodavanehoDokumentuSeznamDto>;
        private SeznamPriloh: GPrilohyPodavanehoDokumentuSeznamDto[];
        private IsFormaEnabled: boolean;
        private IsPodobaEnabled: boolean;
        private prizRezimUtaj: boolean;
        private wfl_pristupypri: number;
        private FilterStUtajIdForFieldPristup: any;
        private gin_rad_priektg: number;
        private gin_rad_priektv: string;
        /**
         * OnContentReady.
         *
         * @author  dsebesta
         * @date    01.09.2017
         */
        public onContentReady(): void {
            const that: GPrilohyPodavanehoDokumentuDlg = this;

            this.beginOperation();
      

            this.createAction();
            this.vytvoritGrid();
            this.enableAction();

            this.endOperation();

        }

        private createAction(): void{
            var that = this;


            this.actions.add(new GAction({
                name: "actNovy",
                icon: "gi-plus",
                caption: "jres:31950369", //RC 31950369 : Nový

                run: function (ev, actionContext) {
                    that.pridatNovy();
                }

            }));

            this.actions.add(new GAction({
                name: "actVymazat",
                icon: "gi-bin",
                caption: "jres:31950308", //RC 31950308 : Vymazat
                enabled:false,
                run: function (ev, actionContext) {
                    var selection = that.mainGrid.ggrid("getSelection");
                    if (selection != null && selection.length > 0) {
                        that.vymazat(selection[0]);
                    }
                }

            }));

            this.actions.add(new GAction(Gordic.Prefabs.Actions.ZavritContent(
            )));

            this.actions.add(new GAction({
                name: "actUlozit",
                icon: "gi-save",
                caption: "jres:31950370", //RC 31950370 : Použít
                run: function (ev, actionContext) {
                    that.ulozitData();
                }

            }));

        

            this.menuBar(this.actions.createBar(
                [
                    { action: this.actions.actNovy, favorite: true },
                    { action: this.actions.actVymazat, favorite: true }

                ]
            ));
            this.commandBar(this.actions.createBar([
                { action:this.actions.actUlozit,primary:true},
                Gordic.Prefabs.Actions.Names.ZavritContent
                ]
            ));
        }



        private vytvoritGrid(): void {
            var that = this;

            var gridKolonky = new Gordic.Data.GridFormat();

            gridKolonky
                .addNumberColumn({
                    name: "poradi",
                    caption: "jres:31950371", //RC 31950371 : Pořadí
                })
                .addTextColumn({
                    name: "obsah",
                    caption: "jres:31950372", //RC 31950372 : Obsah
                    editor: { widget: "gstringbox" },
                })
                .addTextColumn({
                    name: "poznamka",
                    caption: "jres:31950373", //RC 31950373 : Poznamka
                    editor: { widget: "gstringbox" },
                })
                .addNumberColumn({
                    name: "pocet",
                    caption: "jres:31950374", //RC 31950374 : Počet
                    editor: { widget: "gnumberbox" },
                });
            var isEditable = true;
            var arrayOfGin_rad_priektv = undefined;
            if (this.gin_rad_priektv && this.gin_rad_priektv !== "") {
                arrayOfGin_rad_priektv = this.gin_rad_priektv.split(',').map(function (item) {
                    return parseInt(item, 10);
                });
            }
            gridKolonky
                .addTextColumn({
                    width: 125,
                    name: "ktgTypPri",
                    caption: "jres:31950375", //RC 31950375 : Kategorie
                    cellTemplate:"{ktgTypPri_txt}",
                    editor: isEditable ? {
                        widget: "gselectbox",
                        options: [
                            {
                                model: "model.ktgTypPri=value.ktg_typ_pri;model.ktgTypPri_txt=value.ktg_typ_pri_txt",
                                serverFilters: {
                                    ktg_typ_pri: (this.gin_rad_priektg == 2 || this.gin_rad_priektg == 3) ? arrayOfGin_rad_priektv : undefined
                                },
                                validators: [new Gordic.Validators.Required()]
                            },
                            Gordic.Prefabs.Select.wflcktp() //GWflcktp
                        ]
                    } : undefined
                })
                ;

            if (this.IsFormaEnabled) {
                gridKolonky
                    .addTextColumn({
                        width: 125,
                        name: "stUtajId",
                        caption: "jres:31950376", //RC 31950376 : Přístup
                        cellTemplate: "{stUtajId_txt}",
                        editor: isEditable ? {
                            widget: "gselectbox",
                            options: [
                               
                                Gordic.Prefabs.Select.gincstu(), //GWflcktp
                                {
                                    model: "model.stUtajId=value.st_utaj_id;model.stUtajId_txt=value.st_utaj_id_txt",
                                    serverFilters: {
                                        st_utaj_id: this.FilterStUtajIdForFieldPristup,
                                        st_utaj_id_orig: this.wfl_pristupypri === 0 ? "!= 40" : undefined, // MOŽNÁ operátor  <>
                                        gintreu: this.prizRezimUtaj ? true : undefined,
                                    },
                                }
                            ]
                        } : undefined
                    })
                    ;

                gridKolonky
                    .addTextColumn({
                        width: 125,
                        name: "formaPrilohy",
                        caption: "jres:31950377", //RC 31950377 : Podoba přílohy
                        cellTemplate: "{formaPrilohy_txt}",
                        editor: isEditable ? {
                            widget: "gselectbox",
                            options: [
                                {
                                    model: "model.formaPrilohy=value.forma_prilohy;model.formaPrilohy_txt=value.forma_prilohy_txt"
                                },
                                Gordic.Prefabs.Select.wflcfor() //GWflcktp
                            ]
                        } : undefined
                    })
                    ;
            }// !!!!!!        formaPrilohy typPrilohy   MAJÍ NASCHVAL PROHOZENÉ labely protože to tak datově prostě je. 

            if (this.IsPodobaEnabled) {
                gridKolonky
                    .addTextColumn({
                        width: 125,
                        name: "typPrilohy",
                        caption: "jres:31950378", //RC 31950378 : Forma přílohy
                        cellTemplate: "{typPrilohy_txt}",
                        editor: isEditable ? {
                            widget: "gselectbox",
                            options: [
                                {
                                    model: "model.typPrilohy=value.typ_prilohy;model.typPrilohy_txt=value.typ_prilohy_txt"
                                },
                                Gordic.Prefabs.Select.wflcprt() //GWflcktp
                            ]
                        } : undefined
                    })
                    ;
            }
            gridKolonky
                .addDateTimeColumn({
                    name: "dat_zmena",
                    caption: "jres:31950379", //RC 31950379 : Datum změny
                })
                .addTextColumn({
                    name: "nazev_rf",
                    caption: "jres:31950380" //RC 31950380 : Změnu provedl
                });
            
            if (this.SeznamPriloh == null || this.SeznamPriloh.length === 0) {
                this.SeznamPriloh = [];
            }
            this.view = new Gordic.Data.View<GPrilohyPodavanehoDokumentuSeznamDto>(this.SeznamPriloh, { key: "poradi" });

            this.mainGrid = $("<div>").appendTo(this.element).gautofit()
                .ggrid<GPrilohyPodavanehoDokumentuSeznamDto>({
                    name: "mainGrid",
                    data: this.view,
                    renderMode: "auto", // auto, all-at-once, paged-sync, paged-async
                    columnMode: "fit",  // fit, full
                    navigationMode: "row", // row, cell
                    //defaultAction: $.content(this).actions.actDoubleClickDokumentu, //selectAction
                    //rowsClass: function (dataRow) {
                    //    if (dataRow && dataRow.data && dataRow.data.aktivita !== 100) { //aktivita_ds
                    //        return " ui-disabled data-deleted ";
                    //    } else return " ";
                    //},
                    selection: function (ev, row) {
                        that.enableAction();
                    },

                    columns: gridKolonky
                }).ggridroweditor<GPrilohyPodavanehoDokumentuSeznamDto>({
                    save: function (data, info) {
                        //return $.content(this).call("saveData", { dto: data });
                    }
                })
                ;

        }

        private enableAction(): void {
            var that = this;
            if (Gordic.Utils.WidgetExists("ggrid",that.mainGrid)) { 
                var selection = that.mainGrid.ggrid("getSelection");
                if (selection != null && selection.length > 0) {
                    this.actions.actVymazat.enabled(true);
                }
                else {
                    this.actions.actVymazat.enabled(false);
                }
            } 
        }
        private pridatNovy(): void {
            var that = this;
            this.ziskejDataProNovyRadek();
        }
        private ziskejDataProNovyRadek() {
            var that = this;


            this.call("ZiskejDataProNovyRadek", {})
                .then(function (newrow) {
                    var data = that.view.getDataRows();
                    newrow.poradi = data.length + 1;
                    that.mainGrid.ggridroweditor("addRow", newrow);

                });
        }

        private vymazat(row: GPrilohyPodavanehoDokumentuSeznamDto): void {
            var that = this;
            this.view.updateData(row, "delete"); //ViewUpdateMode = "add" | "update" | "extend" | "refresh" | "delete" | "set" | "reset";
            this.prepocitejPoradi();
        }

        private prepocitejPoradi(): void {
            var that = this;
            var data = this.view.getDataRows();
            for (var i = 0; i < data.length; i++) {
                data[i].poradi = i + 1; 
            }
            this.view.updateData(data, "set");
        }

        private ulozitData(): void {
            var that = this;
            var data = this.view.getDataRows();
            if (this.mainGrid.find(".row.editing").length > 0) {
                this.showFlash("jres:31950368","info","idUknoceniEditace") //RC 31950368 : Nejdříve prosím ukončete editaci řádku v seznamu
                return;
            }

            var ret = {
                SeznamPriloh: data
            };
            this.tryClose(ret);

        }
    }

}